import { render, staticRenderFns } from "./cBaseSkillsAdmin.vue?vue&type=template&id=729ce995&scoped=true"
import script from "./cBaseSkillsAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./cBaseSkillsAdmin.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cBaseSkillsAdmin.vue?vue&type=style&index=0&id=729ce995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ce995",
  null
  
)

export default component.exports